import { OptionalEnumSchema } from 'notable-common';
import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
import { FlowRestRequestBodyFormat, FlowRestResponseBodyFormat } from './shared/bodyFormat.js';
export const FLOW_REST_METHOD_AND_ENDPOINT_HELPER_TEXT = 'Enter API method and the full URL for API endpoint.';
/**
 * Structural validation only. flow-api layers on a check that each secure header's domain matches
 * the endpoint, which needs the database and so cannot live here.
 */
export const FlowRestBlockConfigSchema = z.object({
    endpoint: z.string().min(4, {
        message: `Required - ${FLOW_REST_METHOD_AND_ENDPOINT_HELPER_TEXT}`,
    }),
    secureHeaders: z
        .array(z.object({
        id: z.uuid(),
    }))
        .optional(),
    selectedResponseHeaders: z.array(z.string()).optional(),
    method: z.enum(['GET', 'POST', 'PUT', 'PATCH', 'DELETE']),
    headers: z
        .array(z.object({
        key: z.string().min(1, {
            message: 'Header key cannot be empty.',
        }),
        value: z.string().min(1, {
            message: 'Header value cannot be empty.',
        }),
    }))
        .optional(),
    bodyFormat: OptionalEnumSchema(FlowRestRequestBodyFormat, FlowRestRequestBodyFormat.RawJson),
    responseBodyFormat: OptionalEnumSchema(FlowRestResponseBodyFormat, FlowRestResponseBodyFormat.AutoDetect),
    params: z.string().optional(),
    body: z.string().optional(),
});
export const FlowRestBlockBaseSchema = z.object({
    type: z.literal(FlowBlockType.Rest),
    config: FlowRestBlockConfigSchema,
});
export const FlowRestBlockSchema = BaseFlowBlockSchema.extend(FlowRestBlockBaseSchema.shape);
//# sourceMappingURL=config.js.map